import React from "react";
import { LayoutMain } from "@unisearch/theme/layout";
import {
  ElearningHomeHero,
  ElearningHomeIntro,
  ElearningHomeOnlineTest,
  ElearningHomeSteps,
} from "@modules/elearning/home";

const Elearning = () => {
  return (
    <LayoutMain
      footer_with_evaluation
      title="eLearning"
      metaUrl={`${process.env.NEXT_PUBLIC_URL}/elearning`}
    >
      <ElearningHomeHero />
      <ElearningHomeIntro />
      <ElearningHomeOnlineTest />
      <ElearningHomeSteps />
    </LayoutMain>
  );
};

export default Elearning;
